// extracted by mini-css-extract-plugin
export default {"before":"SlotButtonGroup_before__JVt9A","root":"SlotButtonGroup_root__s-3BE","button":"SlotButtonGroup_button__kN6RW","singleRow":"SlotButtonGroup_singleRow__6c6WK"};